import React from 'react';
import { WidgetImage } from '../WidgetImage/WidgetImage';
import { WidgetFeature } from '../Widget';
import { WidgetClickedElement } from '../../../../stores/UiLoggerStore';
import { WithTranslations, withTranslations } from '../../../../../utils/withTranslations';
import { widgetFeatureSlideDataHooks } from './WidgetFeatureSlide.dataHooks';
import styles from './WidgetFeatureSlide.scss';

interface WidgetFeatureSlideProps extends WithTranslations {
  feature: WidgetFeature;
  createElementClickHandler: (element: WidgetClickedElement) => (e: React.MouseEvent) => void;
  dataHook?: string;
}

const WidgetFeatureSlideCmp: React.FC<WidgetFeatureSlideProps> = ({
  feature,
  createElementClickHandler,
  t,
  dataHook,
}) => (
  <div className={styles.container} data-hook={dataHook}>
    <div
      className={styles.imageWrapper}
      onClick={createElementClickHandler('Tool Image')}
      data-hook={widgetFeatureSlideDataHooks.imageWrapper()}
    >
      <WidgetImage imageClassName={styles.image} feature={feature} dataHook={widgetFeatureSlideDataHooks.image()} />
    </div>
    <div
      className={styles.title}
      onClick={createElementClickHandler('Tool Title')}
      data-hook={widgetFeatureSlideDataHooks.title()}
    >
      {t(feature.title)}
    </div>
    <div
      className={styles.description}
      onClick={createElementClickHandler('Tool Description')}
      data-hook={widgetFeatureSlideDataHooks.description()}
    >
      {t(feature.description)}
    </div>
  </div>
);

export const WidgetFeatureSlide = withTranslations(WidgetFeatureSlideCmp);
